export default __webpack_public_path__ + "static/media/thank_you.66aa5e77.svg";